import api from './api';

// DTOs từ HIS
export interface DmLoaiDichVuDto {
  maLoaiDichVu: number;
  tenLoaiDichVu: string;
}

export interface DmDichVuDto {
  mahh: number;
  maView: string;
  stt: number | null;
  bn100: boolean | null;
  khongLamCls: boolean | null;
  andi: boolean | null;
  tenDichVu: string;
}

export interface DmMayClsDto {
  instrumentID: string;
  insName: string;
  maMay: string;
  dinhMuc: number | null;
  maNoiThucHien: number | null;
  soCa: number | null;
  macu: string;
  checkTimeDistance: boolean;
  kiemTraTG: boolean | null;
  ksd: boolean;
}

// DTO từ Portal
export interface MappingDvMayDto {
  id: number;
  mahh: number;
  instrumentID: string;
  createdAt: Date | null;
}

// DTO từ Portal có thêm tên dịch vụ và tên máy (từ HIS)
export interface MappingDvMayWithNamesDto {
  id: number;
  mahh: number;
  instrumentID: string;
  createdAt: Date | null;
  tenDichVu: string;
  insName: string;
}

export interface CreateMappingDvMayRequestDto {
  mahh: number;
  instrumentID: string;
}

export interface BatchCreateMappingDvMayRequestDto {
  mappings: CreateMappingDvMayRequestDto[];
}

export const mappingDvMayService = {
  // Lấy danh sách loại dịch vụ từ HIS
  async getDmLoaiDichVu(): Promise<DmLoaiDichVuDto[]> {
    const res = await api.get('/sync/dmloaidichvu');
    return (res.data || []).map((r: any) => ({
      maLoaiDichVu: r.maLoaiDichVu ?? r.MaLoaiDichVu,
      tenLoaiDichVu: r.tenLoaiDichVu ?? r.TenLoaiDichVu
    }));
  },

  // Lấy danh sách dịch vụ từ HIS
  async getDmDichVu(maLoaiDichVu?: number, searchText?: string): Promise<DmDichVuDto[]> {
    const params: any = {};
    if (maLoaiDichVu !== undefined) params.maLoaiDichVu = maLoaiDichVu;
    if (searchText !== undefined) params.searchText = searchText;

    const res = await api.get('/sync/dmdichvu', { params });
    return (res.data || []).map((r: any) => ({
      mahh: r.mahh ?? r.Mahh,
      maView: r.maView ?? r.MaView,
      stt: r.stt ?? r.Stt ?? null,
      bn100: r.bn100 ?? r.Bn100 ?? null,
      khongLamCls: r.khongLamCls ?? r.KhongLamCls ?? null,
      andi: r.andi ?? r.Andi ?? null,
      tenDichVu: r.tenDichVu ?? r.TenDichVu
    }));
  },

  // Lấy danh sách máy CLS từ HIS
  async getDmMayCls(searchText?: string): Promise<DmMayClsDto[]> {
    const params: any = {};
    if (searchText !== undefined) params.searchText = searchText;

    const res = await api.get('/sync/dmmaycls', { params });
    return (res.data || []).map((r: any) => ({
      instrumentID: r.instrumentID ?? r.InstrumentID,
      insName: r.insName ?? r.InsName,
      maMay: r.maMay ?? r.MaMay,
      dinhMuc: r.dinhMuc ?? r.DinhMuc ?? null,
      maNoiThucHien: r.maNoiThucHien ?? r.MaNoidoiThucHien ?? null,
      soCa: r.soCa ?? r.SoCa ?? null,
      macu: r.macu ?? r.Macu,
      checkTimeDistance: r.checkTimeDistance ?? r.CheckTimeDistance,
      kiemTraTG: r.kiemTraTG ?? r.KiemTraTG ?? null,
      ksd: r.ksd ?? r.Ksd
    }));
  },

  // Lấy tất cả mapping từ Portal (có tên dịch vụ và tên máy từ HIS)
  async getAllMappingDvMay(): Promise<MappingDvMayWithNamesDto[]> {
    const res = await api.get('/sync/mapping-dv-may');
    return (res.data || []).map((r: any) => ({
      id: r.id ?? r.Id,
      mahh: r.mahh ?? r.Mahh,
      instrumentID: r.instrumentID ?? r.InstrumentID,
      createdAt: r.createdAt ?? r.CreatedAt ? new Date(r.createdAt ?? r.CreatedAt) : null,
      tenDichVu: r.tenDichVu ?? r.TenDichVu,
      insName: r.insName ?? r.InsName
    }));
  },

  // Tạo một mapping
  async createMappingDvMay(mahh: number, instrumentID: string): Promise<{ id: number; message: string }> {
    const res = await api.post('/sync/mapping-dv-may', { mahh, instrumentID });
    return {
      id: res.data.id ?? res.data.Id,
      message: res.data.message ?? res.data.Message
    };
  },

  // Tạo nhiều mapping cùng lúc
  async batchCreateMappingDvMay(mappings: CreateMappingDvMayRequestDto[]): Promise<{ count: number; message: string }> {
    const res = await api.post('/sync/mapping-dv-may/batch', { mappings });
    return {
      count: res.data.count ?? res.data.Count,
      message: res.data.message ?? res.data.Message
    };
  },

  // Xóa mapping
  async deleteMappingDvMay(id: number): Promise<{ message: string }> {
    const res = await api.delete(`/sync/mapping-dv-may/${id}`);
    return {
      message: res.data.message ?? res.data.Message
    };
  },

  // Kiểm tra mapping đã tồn tại chưa
  async checkMappingExists(mahh: number, instrumentID: string): Promise<{ exists: boolean }> {
    const res = await api.get('/sync/mapping-dv-may/check', {
      params: { mahh, instrumentID }
    });
    return {
      exists: Boolean(res.data.exists ?? res.data.Exists ?? false)
    };
  }
};
